// The server's current time in the reporting time zone (UK time by default, BST/GMT switching
// automatically). Synced with the server every 10 minutes so a wrong device clock doesn't matter.
import { useEffect, useState } from 'react';
import { useServerTimeQuery } from '../app/api';
import { zonedParts } from '../lib/format';

export function ServerClock({ timeZone }: { timeZone: string }) {
  const { data } = useServerTimeQuery(undefined, { pollingInterval: 10 * 60_000 });
  const tz = data?.timeZone ?? timeZone;
  const offset = data?.offsetMs ?? 0;
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    let tick: ReturnType<typeof setInterval> | undefined;
    // Tick on the server's second boundary.
    const start = setTimeout(() => {
      setNow(Date.now());
      tick = setInterval(() => setNow(Date.now()), 1000);
    }, 1000 - ((Date.now() + offset) % 1000));
    return () => {
      clearTimeout(start);
      if (tick) clearInterval(tick);
    };
  }, [offset]);
  const at = new Date(now + offset);
  const p = zonedParts(at, tz);
  const label = `${p.weekday} ${p.day} ${p.month} ${p.year}, ${p.hour}:${p.minute}:${p.second} ${p.timeZoneName}`;
  return (
    <time className="server-clock" dateTime={at.toISOString()} title={`Server time (${tz}): ${label}`} aria-label={`Server time ${label}`}>
      <span className="clock-date">
        {p.weekday} {p.day} {p.month}
      </span>
      <span className="clock-time">
        {p.hour}:{p.minute}
        <span className="clock-sec">:{p.second}</span>
      </span>
      <span className="clock-zone">{p.timeZoneName}</span>
    </time>
  );
}
